import React from "react";
import { inject, observer } from "mobx-react";
import { CardBody, CardContainer, CardHeader } from "best-common-react";
import AddOn from "../addOns/AddOn";
import styled from "styled-components";

const AddButton = styled.button`
  &&& {
    background-color: white;
    border-color: #d2d2d2;
  }
`;

function OrgSeasonAddOnContainer(props) {
  const { commonStore, orgAdminStore } = props.rootStore;

  const addOns = orgAdminStore.addOns.filter(a => a.season.seasonId === props.season.seasonId);

  return (
    <CardContainer>
      <CardHeader>{props.season.seasonType.seasonTypeName}</CardHeader>
      <CardBody>
        {addOns
          .filter(a => !a.deleted)
          .map((ad, ix) => (
            <AddOn
              key={ix}
              addOn={ad}
              departmentOptions={orgAdminStore.departmentOptions}
              homeAwayOptions={orgAdminStore.homeAwayOptions}
            />
          ))}
        <div className="d-flex justify-content-end mt-2">
          <AddButton className="btn" onClick={() => orgAdminStore.addNewAddOn(props.season)} id="section-early">
            Add Add-On
          </AddButton>
        </div>
      </CardBody>
    </CardContainer>
  );
}

export default inject("rootStore")(observer(OrgSeasonAddOnContainer));
